import React from 'react';
import { classNames, layoutClassNames, LayoutClassNameProps } from './classNames';

export interface IconProps extends React.HTMLAttributes<HTMLElement>, LayoutClassNameProps {
  name: string;
  label?: string;
}

const Icon: React.FC<IconProps> = ({
  name,
  label,
  className,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  ...props
}) => (
  <i
    className={classNames(
      'bi',
      `bi-${name}`,
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      className,
    )}
    aria-hidden={label ? undefined : true}
    aria-label={label}
    role={label ? 'img' : undefined}
    {...props}
  />
);

export default Icon;
